$(document).ready(function(){
    const $promoted_event = $(".homepage-promoted-event");
    
    if( $promoted_event ){
        const $desktop_image_url = $promoted_event.find(".hero-desktop img").attr("src");
        const $promoted_event_details = $promoted_event.find(".promoted-event-details");
        const field_date = $promoted_event.find(".views-field-field-date .field-content").text();
        const field_event_type = $promoted_event.find(".views-field-field-event-type .field-content").text();
        const field_title = $promoted_event.find(".views-field-title .field-content a").text();
        const href = $promoted_event.find(".views-field-title .field-content a").attr('href');
        const field_vertical_text  = $promoted_event.find(".views-field-field-hero-vertical-text .field-content").text();
        
        $promoted_event.css({"background-image": "url('"+ $desktop_image_url +"')"});
        $promoted_event_details.find(".promoted-event-bottom-text .event-type").text( field_event_type );
        $promoted_event_details.find(".promoted-event-bottom-text .event-title-date .event-title").text( field_title );
        $promoted_event_details.find(".promoted-event-bottom-text .event-title-date .event-date").text( field_date );
        $promoted_event_details.find(".promoted-event-bottom-text").attr('href', href);
        $promoted_event_details.find(".promoted-event-vertical-text span").text( field_vertical_text );
    }
})